// @flow

import { createStore, compose, applyMiddleware } from 'redux';
import { addLocaleData } from 'react-intl';
import thunk from 'redux-thunk';
import axios from 'axios';
import en from 'react-intl/locale-data/en';
import ru from 'react-intl/locale-data/ru';

import rootReducer from './rootReducer';
import intlData from '../intl';

addLocaleData([...en, ...ru]);
const defaultLocale = 'ru';

export default function configureStore(initialState?: Object  = {}) {
  const enhancers = compose(
    // Middleware store enhancer.
    applyMiddleware(
      // Initialising redux-thunk with extra arguments will pass the below
      // arguments to all the redux-thunk actions. Below we are passing a
      // preconfigured axios instance which can be used to fetch data with.
      // @see https://github.com/gaearon/redux-thunk
      thunk.withExtraArgument({ axios }),
    ),
    // Redux Dev Tools store enhancer.
    // @see https://github.com/zalmoxisus/redux-devtools-extension
    // We only want this enhancer enabled for development and when in a browser
    // with the extension installed.
    process.env.NODE_ENV === 'development'
      && typeof window !== 'undefined'
      && typeof window.devToolsExtension !== 'undefined'
      // Call the brower extension function to create the enhancer.
      ? window.devToolsExtension()
      // Else we return a no-op function.
      : f => f,
  );
  const state = {
    intl: {
      locale: defaultLocale,
      messages: intlData[defaultLocale],
    },
    ...initialState,
  };

  return createStore(rootReducer, state, enhancers);
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js